import { createRouter } from '@tanstack/react-router'
import { queryClient } from '../query-client'
import { routeTree } from './routeTree.gen'

// session кладётся null; _app beforeLoad заполняет её из /api/employees/me.
export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
